(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cercevo-experience"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.CercevoExperience) return;
  const host = document.querySelector('#cx-experience');
  if (!host) return;
  const t = JSON.parse(host.querySelector('[data-cx-i18n]').textContent);
  const root = host.dataset.root || '/';
  const preview = host.dataset.preview === 'true';
  const $ = (s) => host.querySelector(s);
  const safeRead = (key, fallback, storage = localStorage) => { try { return JSON.parse(storage.getItem(key)) || fallback; } catch { return fallback; } };
  const safeWrite = (key, value, storage = localStorage) => { try { storage.setItem(key, JSON.stringify(value)); } catch {} };
  const key = `cercevo:favorites:${location.hostname}`;
  const reelSeenKey = `cercevo:reel-seen:${location.hostname}`;
  const randomStartKey = `cercevo:random-start:${location.hostname}`;
  let ids = new Set(safeRead(key, []).map(String));
  let reelSeen = new Set(safeRead(reelSeenKey, [], sessionStorage).map(String));
  const savedProducts = safeRead(`${key}:products`, {});
  const known = new Map();
  const cache = new Map();
  const reel = $('[data-cx-reel]');
  const listDialog = $('[data-cx-save-dialog]');
  const state = { products: [], index: 0, next: '', url: '', origin: null, busy: false, variant: null, revision: 0, source: null, returnFocus: null, loaded: false, startedId: '', seedProducts: null };
  function parseProducts(node) { return [...node.querySelectorAll('[data-cercevo-product]')].flatMap(n => { try { return [JSON.parse(n.textContent)]; } catch { return []; } }); }
  function remember(products) { products.forEach(p => known.set(String(p.id), p)); return products; }
  remember(parseProducts(document));
  function syncSaved() {
    document.querySelectorAll('[data-cx-saved-count]').forEach(n => n.textContent = ids.size);
    document.querySelectorAll('[data-cercevo-favorite]').forEach(n => {
      const active = ids.has(String(n.dataset.productId)); n.setAttribute('aria-pressed', String(active)); n.classList.toggle('is-favorited', active);
    });
    const p = state.products[state.index];
    if (p) { $('[data-cx-heart]').textContent = ids.has(String(p.id)) ? '♥' : '♡'; $('[data-cx-heart]').setAttribute('aria-pressed', String(ids.has(String(p.id)))); }
  }
  let toastTimer;
  function toast(message) { const n=$('[data-cx-toast]');n.textContent=message;n.hidden=false;clearTimeout(toastTimer);toastTimer=setTimeout(()=>n.hidden=true,2800); }
  function save(p, addOnly = false) {
    if (!p) return;
    const id=String(p.id);
    if (ids.has(id) && !addOnly) {ids.delete(id);delete savedProducts[id];} else {ids.add(id);savedProducts[id]={id:p.id,title:p.title,url:p.url,image:p.image};if(addOnly)toast(t.saved_notice);}
    safeWrite(key,[...ids]);safeWrite(`${key}:products`,savedProducts);syncSaved();
    document.dispatchEvent(new CustomEvent('cercevo:favorites-change'));
  }
  async function feed(path) {
    const url=new URL(path,location.origin);if(url.origin!==location.origin)throw Error('Invalid source');
    url.searchParams.set('section_id','cercevo-explore-feed');url.searchParams.delete('view');
    if(cache.has(url.href))return cache.get(url.href);
    const promise=(async()=>{
      const response=await fetch(url,{signal:AbortSignal.timeout(12000)});if(!response.ok)throw Error('Feed');
      const html=new DOMParser().parseFromString(await response.text(),'text/html');const el=html.querySelector('[data-explore-feed]');if(!el)throw Error('Missing feed');
      const products=remember(parseProducts(el));
      return {products,next:el.dataset.next,total:Number(el.dataset.total),pages:Number(el.dataset.pages),page:Number(el.dataset.page),filters:JSON.parse(el.querySelector('[data-cx-filters]')?.textContent||'[]')};
    })();
    cache.set(url.href,promise);if(cache.size>20)cache.delete(cache.keys().next().value);
    try{return await promise;}catch(e){cache.delete(url.href);throw e;}
  }
  function quickVariant(product) {
    const type=(product.type || '').toLocaleLowerCase('tr');
    const base=type.includes('saat') ? null : type.includes('kanvas') ? [45,70] : type.includes('cam') ? [40,60] : null;
    if(!base)return null;
    const variants=(product.variants||[]).filter(v=>v.available && (v.options||[]).some(option=>{
      const m=String(option).match(/^\s*(\d+)\s*[x×X]\s*(\d+)\s*(?:cm)?\s*$/i);return m&&[+m[1],+m[2]].sort((a,b)=>a-b).join()===base.join();
    }));
    return variants.length===1?variants[0]:null;
  }
  function contextURL() {const u=new URL(location.href);u.hash='';u.searchParams.delete('section_id');u.searchParams.delete('page');return u.pathname.includes('/collections/')?u.pathname+u.search:host.dataset.collectionUrl;}
  function closeMenus() {document.querySelectorAll('[data-cx-inert]').forEach(el=>{el.inert=false;delete el.dataset.cxInert;});document.querySelectorAll('cercevo-explore-nav').forEach(n=>{n.classList.remove('is-open');n.querySelector('[data-cx-menu]')?.setAttribute('aria-expanded','false');n.querySelectorAll('details[open]').forEach(d=>d.open=false);const shell=n.querySelector('.cx-nav-shell');if(shell?.open)shell.close();});}
  function current(){return state.products[state.index];}
  function shuffle(products){const mixed=[...products];for(let i=mixed.length-1;i>0;i--){const j=Math.floor(Math.random()*(i+1));[mixed[i],mixed[j]]=[mixed[j],mixed[i]];}return mixed;}
  function mixProducts(products){const unique=[...new Map(products.map(p=>[String(p.id),p])).values()];const unseen=shuffle(unique.filter(p=>!reelSeen.has(String(p.id))));const seen=shuffle(unique.filter(p=>reelSeen.has(String(p.id))));return [...unseen,...seen];}
  function open(p, options={}) {
    if(!p)return;remember([p]);closeMenus();document.querySelectorAll('[data-product-modal][open]').forEach(d=>d.close());
    state.returnFocus=options.returnFocus||document.activeElement;state.origin=options.origin||null;state.source=options.source||null;state.url=options.url||contextURL();
    state.seedProducts=Array.isArray(options.products)&&options.products.length?options.products:null;
    state.products=[p];state.index=0;state.next='';state.busy=false;state.revision++;state.startedId=String(p.id);state.loaded=false;
    $('[data-cx-end]').hidden=true;$('[data-cx-reel-status]').textContent='';reel.showModal();render();if(options.ar&&!$('[data-cx-ar]').parentElement.hidden)$('[data-cx-ar]').click();loadFirst();
  }
  let randomBusy=false;
  async function openRandom(options={}) {
    if(randomBusy)return;
    randomBusy=true;
    const trigger=options.trigger||document.activeElement;
    trigger?.setAttribute?.('aria-busy','true');
    closeMenus();
    const source=root+'collections/all';
    try{
      const first=await feed(source);
      const total=Math.max(first.products.length,Number(first.total)||0);
      const ordinal=Math.floor(Math.random()*Math.max(1,total));
      const page=Math.floor(ordinal/24)+1;
      const result=page===Number(first.page||1)?first:await feed(source+(source.includes('?')?'&':'?')+'page='+page);
      const eligible=result.products.filter(p=>p&&p.available!==false&&p.image);
      if(!eligible.length)throw Error('Empty random page');
      let product=eligible[Math.min(ordinal%24,eligible.length-1)]||eligible[Math.floor(Math.random()*eligible.length)];
      const previous=String(safeRead(randomStartKey,'',sessionStorage)||'');
      if(eligible.length>1&&String(product.id)===previous){
        product=eligible[(eligible.indexOf(product)+1+Math.floor(Math.random()*(eligible.length-1)))%eligible.length];
      }
      safeWrite(randomStartKey,String(product.id),sessionStorage);
      const encounter=document.querySelector('[data-presentation="encounter"]');
      open(product,{url:source,returnFocus:trigger,source:last=>encounter?.cercevoSetEncounter?.(last)});
    }catch{
      const eligible=mixProducts([...known.values()].filter(p=>p&&p.available!==false&&p.image));
      if(eligible[0]){
        const encounter=document.querySelector('[data-presentation="encounter"]');
        open(eligible[0],{url:source,returnFocus:trigger,source:last=>encounter?.cercevoSetEncounter?.(last)});
      }
    }finally{
      trigger?.removeAttribute?.('aria-busy');
      randomBusy=false;
    }
  }
  async function loadFirst(){
    const rev=state.revision;
    if(state.seedProducts&&state.seedProducts.length){
      state.products=[current(),...mixProducts(state.seedProducts.filter(p=>String(p.id)!==state.startedId))];
      state.next=state.url;state.loaded=true;
      state.products.forEach(p=>known.set(String(p.id),p));
      return;
    }
    try{const result=await feed(state.url);if(rev!==state.revision)return;state.products=[current(),...mixProducts(result.products.filter(p=>String(p.id)!==state.startedId))];state.next=result.next;state.loaded=true;state.products.forEach(p=>known.set(String(p.id),p));}catch{$('[data-cx-reel-status]').textContent=t.error;state.loaded=false;}
  }
  function historyRecord(p){const record={...p,source:state.url,scroll:window.scrollY};safeWrite('cercevo:journey',record,sessionStorage);}
  async function render(){
    const p=current();if(!p)return;historyRecord(p);state.variant=null;reelSeen.add(String(p.id));safeWrite(reelSeenKey,[...reelSeen].slice(-400),sessionStorage);
    $('[data-cx-reel-image]').src=p.image||'';$('[data-cx-reel-image]').alt=p.imageAlt||p.title;
    $('#cx-reel-title').textContent=p.title;$('[data-cx-price]').textContent=p.price||'';$('[data-cx-variant]').textContent='';
    $('[data-cx-detail]').href=p.url;$('[data-cx-reel-context]').textContent=p.collectionTitle||t.all;
    $('[data-cx-add]').textContent=t.choose;$('[data-cx-prev]').disabled=state.index===0;$('[data-cx-end]').hidden=true;syncSaved();
    const ar=$('[data-cx-ar]');ar.removeAttribute('rel');ar.parentElement.hidden=!preview&&!(p.models||[]).length;ar.setAttribute('aria-label','Alanınızda görüntüleyin');ar.href=p.url+'#cercevo-ar';ar.replaceChildren();const icon=document.createElement('span');icon.textContent='3D';ar.append(icon);
    const ios=(/iPad|iPhone|iPod/.test(navigator.userAgent)||navigator.platform==='MacIntel'&&navigator.maxTouchPoints>1);
    const usdz=(p.models||[]).find(s=>s.format==='usdz');const glb=(p.models||[]).find(s=>s.format==='glb');
    if(/android/i.test(navigator.userAgent)&&glb){const fallback=new URL(state.url,location.origin);fallback.hash='cx-continue';ar.href='intent://arvr.google.com/scene-viewer/1.0?file='+encodeURIComponent(glb.url)+'&mode=ar_preferred&title='+encodeURIComponent(p.title)+'#Intent;scheme=https;package=com.google.android.googlequicksearchbox;action=android.intent.action.VIEW;S.browser_fallback_url='+encodeURIComponent(fallback.href)+';end;';}
    if(ios&&usdz){ar.rel='ar';ar.href=usdz.url;const thumb=document.createElement('img');thumb.src=p.image;thumb.alt='3D';thumb.style.cssText='width:22px;height:22px;position:static';ar.prepend(thumb);}
    const productId=p.id;const rev=state.revision;
    try{
      let data=p;
      if(!preview){const u=new URL(p.url,location.origin);u.search='';u.hash='';u.pathname+='.js';const r=await fetch(u,{signal:AbortSignal.timeout(10000)});if(!r.ok)return;data=await r.json();}
      if(current()?.id!==productId||rev!==state.revision)return;
      state.variant=quickVariant(data);if(state.variant){$('[data-cx-add]').textContent=t.add;$('[data-cx-variant]').textContent=state.variant.title;$('[data-cx-price]').textContent=new Intl.NumberFormat('tr-TR',{style:'currency',currency:host.dataset.currency||'TRY'}).format(state.variant.price/100);}
    }catch{}
  }
  async function next(){
    if(state.busy)return;
    if(state.index+1<state.products.length){state.index++;render();return;}
    if(!state.loaded){await loadFirst();if(state.products.length>1){state.index++;render();}return;}
    if(!state.next){$('[data-cx-end]').hidden=false;return;}
    state.busy=true;$('[data-cx-reel-status]').textContent=t.loading;
    const rev=state.revision;
    try{const result=await feed(state.next);if(rev!==state.revision)return;const seen=new Set(state.products.map(p=>String(p.id)));state.products.push(...mixProducts(result.products.filter(p=>!seen.has(String(p.id)))));state.next=result.next;$('[data-cx-reel-status]').textContent='';if(state.index+1<state.products.length){state.index++;render();}else if(!state.next)$('[data-cx-end]').hidden=false;}
    catch{$('[data-cx-reel-status]').textContent=t.error;}finally{state.busy=false;}
  }
  async function add(){
    if(state.busy)return;const p=current();if(!state.variant){historyRecord(p);location.href=p.url;return;}
    state.busy=true;const variant=state.variant;const button=$('[data-cx-add]');button.disabled=true;
    try{
      if(preview){$('[data-cx-reel-status]').textContent=t.preview;return;}
      const r=await fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:variant.id,quantity:1}]})});
      if(!r.ok)throw Error('Cart');
      $('[data-cx-reel-status]').textContent=t.cart_notice;$('[data-cx-cart]').hidden=false;
      try{const cart=await (await fetch(root+'cart.js')).json();document.querySelectorAll('cart-icon').forEach(el=>el.renderCartBubble?.(cart.item_count));document.dispatchEvent(new CustomEvent('cercevo:cart-updated',{detail:{cart}}));try{const {CartLinesUpdateEvent}=await import('@shopify/events');const deferred=CartLinesUpdateEvent.createPromise();document.dispatchEvent(new CartLinesUpdateEvent({action:'add',context:'product',lines:[{merchandiseId:String(variant.id),quantity:1}],promise:deferred.promise}));deferred.resolve({cart:CartLinesUpdateEvent.createCartFromAjaxResponse(cart),detail:{items:cart.items,source:'cercevo-experience',itemCount:cart.item_count,sections:{},didError:false}});}catch{}}catch{}
    }catch{$('[data-cx-reel-status]').textContent=t.cart_error;$('[data-cx-cart]').hidden=false;}
    finally{state.busy=false;button.disabled=false;}
  }
  function savedList(){
    const container=$('[data-cx-save-list]');container.replaceChildren();
    if(!ids.size){container.textContent=t.favorite_empty;return;}
    ids.forEach(id=>{
      const p=savedProducts[id]||known.get(id);if(!p)return;
      const row=document.createElement('div');row.className='cx-save-row';const img=document.createElement('img');img.src=p.image||'';img.alt='';img.loading='lazy';const a=document.createElement('a');a.href=p.url;a.textContent=p.title;const remove=document.createElement('button');remove.textContent='×';remove.setAttribute('aria-label',p.title+' — '+t.close);remove.onclick=()=>{save(p);savedList();};row.append(img,a,remove);container.append(row);
    });
    if(!container.children.length)container.textContent=t.favorite_empty;
  }
  const families=[['Form ve Sadelik',['soyut','bauhaus','geometrik','minimalist','iskandinav','cizgi-sanati']],['Doğa ve Manzara',['botanik','deniz-sahil','doga-manzara','hayvan']],['Kültür ve Mekân',['geleneksel-koleksiyon','islami-sanat-ve-mimari','sehir-mimari','vintage']],['İllüstrasyon ve İfade',[]]];
  const norm=s=>s.normalize('NFKD').replace(/[̀-ͯ]/g,'').toLowerCase();
  function setupNav(nav){if(nav.dataset.ready)return;nav.dataset.ready='true';
    if(nav.classList.contains('cx-nav--mobile')){const shortcuts=nav.querySelector('.cx-shortcuts')?.cloneNode(true);if(shortcuts)nav.querySelector('.cx-nav-shell').append(shortcuts);}
    const links=nav.querySelector('[data-cx-style-links]');if(links){const items=[...links.querySelectorAll('a')];const buckets=families.map(([name])=>{const box=document.createElement('div');box.className='cx-style-family';box.dataset.expanded='false';const heading=document.createElement('strong');const toggle=document.createElement('button');toggle.type='button';toggle.textContent=name;toggle.setAttribute('aria-expanded','false');toggle.onclick=()=>{box.dataset.expanded=String(box.dataset.expanded!=='true');toggle.setAttribute('aria-expanded',box.dataset.expanded);};heading.append(toggle);box.append(heading);links.append(box);return box;});items.forEach(a=>{let i=families.findIndex(f=>f[1].includes(norm(a.dataset.cxCollection||'')));if(i<0)i=3;buckets[i].append(a);});}
    nav.addEventListener('click',e=>{if(e.target.closest('[data-cx-menu]')){nav.classList.add('is-open');const shell=nav.querySelector('.cx-nav-shell');shell.setAttribute('aria-label',t.all);if(typeof shell.showModal==='function'&&!shell.open)shell.showModal();else document.querySelectorAll('main,footer').forEach(el=>{if(!el.inert){el.inert=true;el.dataset.cxInert='true';}});e.target.closest('button').setAttribute('aria-expanded','true');nav.querySelector('[data-cx-menu-close]').focus();}if(e.target.closest('[data-cx-menu-close]')){closeMenus();nav.querySelector('[data-cx-menu]').focus();}if(e.target.closest('[data-cx-back]')){const d=e.target.closest('details');d.open=false;d.querySelector('summary').focus();}});
    nav.addEventListener('keydown',e=>{if(e.key!=='Tab'||!nav.classList.contains('is-open'))return;const scope=nav.querySelector('details[open] .cx-panel')||nav.querySelector('.cx-nav-shell');const controls=[...scope.querySelectorAll('a,button,input,summary')].filter(n=>n.getClientRects().length);const first=controls[0],last=controls.at(-1);if(e.shiftKey&&document.activeElement===first){e.preventDefault();last?.focus();}else if(!e.shiftKey&&document.activeElement===last){e.preventDefault();first?.focus();}});
    nav.querySelectorAll('details').forEach(d=>d.addEventListener('toggle',()=>{if(d.open)nav.querySelectorAll('details').forEach(other=>{if(other!==d)other.open=false;});}));
    nav.querySelector('[data-cx-search]')?.addEventListener('input',e=>{const q=norm(e.target.value);links.querySelectorAll('a').forEach(a=>a.hidden=!norm(a.textContent).includes(q));links.querySelectorAll('.cx-style-family').forEach(b=>{b.dataset.expanded=String(!!q);b.hidden=![...b.querySelectorAll('a')].some(a=>!a.hidden);});});
    nav.querySelectorAll('a').forEach(a=>{if(!a.hash && new URL(a.href,location.origin).pathname===location.pathname)a.setAttribute('aria-current','page');});
    const journey=safeRead('cercevo:journey',null,sessionStorage);
    nav.querySelectorAll('[data-cx-context]').forEach(n=>{if(host.dataset.collectionTitle){const label=document.createElement('span');label.textContent=t.source+': '+host.dataset.collectionTitle;n.append(label);for(const [k,v]of new URLSearchParams(location.search)){if(k.startsWith('filter.')){const chip=document.createElement('a');const u=new URL(location.href);u.searchParams.delete(k,v);chip.href=u.href;chip.textContent=v+' ×';n.append(chip);}}}if(journey){const a=document.createElement('a');a.textContent=t.continue+' · '+journey.title;a.href=journey.source+'#cx-continue';n.append(a);}});
  }
  document.addEventListener('click',e=>{
    let cardButton=e.target.closest('[data-cx-card-open]');if(!cardButton&&e.target.closest('.cx-last-card>a,product-card .card-gallery a'))cardButton=e.target.closest('.cx-last-card,product-card')?.querySelector('[data-cx-card-open]');
    if(cardButton){e.preventDefault();e.stopPropagation();const tools=cardButton.closest('[data-cx-card-tools]');const p=parseProducts(tools)[0];const card=cardButton.closest('product-card')||cardButton.closest('.cx-last-card');
      open(p,{url:host.dataset.collectionTitle?contextURL():(tools.dataset.cxSource||contextURL()),origin:card,source:last=>{if(!last||last.id===p.id||!card)return;const replacement=document.createElement('article');replacement.className='cx-last-card';const link=document.createElement('a');link.href=last.url;const img=document.createElement('img');img.src=last.image||'';img.alt=last.title;img.width=400;img.height=500;const title=document.createElement('h3');title.textContent=last.title;const price=document.createElement('p');price.textContent=last.price;link.append(img,title,price);replacement.append(link);const toolbar=tools.cloneNode(true);toolbar.querySelector('[data-cercevo-product]').textContent=JSON.stringify(last);toolbar.querySelector('a')?.remove();if(last.models?.length){const ar=document.createElement('a');ar.href=last.url+'#cercevo-ar';ar.textContent='3D';toolbar.append(ar);}replacement.append(toolbar);card.replaceWith(replacement);replacement.querySelector('button').focus({preventScroll:true});}});return;}
    if(e.target.closest('[data-cx-saved]')){closeMenus();savedList();listDialog.showModal();}
    if(e.target.closest('[data-cx-save-close]'))listDialog.close();
    if(e.target.closest('[data-cx-close]'))reel.close();
    if(e.target.closest('[data-cx-next]'))next();
    if(e.target.closest('[data-cx-prev]')&&state.index>0&&!state.busy){state.index--;render();}
    if(e.target.closest('[data-cx-heart]'))save(current());
    if(e.target.closest('[data-cx-add]'))add();
    if(e.target.closest('[data-cx-broaden]')){const p=current();open(p,{url:root+'collections/all',source:state.source});}
    const random=e.target.closest('[data-cx-random]');if(random){e.preventDefault();openRandom({trigger:random});}
    const ar=e.target.closest('[data-cx-ar]');if(ar){historyRecord(current());if(preview){e.preventDefault();$('[data-cx-reel-status]').textContent=t.preview;}}
    if(e.target.closest('[data-cx-detail]'))historyRecord(current());
    if(!e.target.closest('cercevo-explore-nav'))document.querySelectorAll('.cx-nav--desktop details[open]').forEach(d=>d.open=false);
  },true);
  reel.addEventListener('click',e=>{if(e.target!==reel)return;const r=reel.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)reel.close();});
  reel.addEventListener('close',()=>{state.revision++;state.source?.(current());state.returnFocus?.focus?.({preventScroll:true});});
  document.addEventListener('keydown',e=>{if(e.key==='Escape'){closeMenus();}if(!reel.open||/INPUT|SELECT|TEXTAREA/.test(e.target.tagName))return;if(e.key==='ArrowDown'){e.preventDefault();next();}if(e.key==='ArrowUp'&&state.index>0){e.preventDefault();state.index--;render();}if(e.key==='ArrowRight')reel.close();if(e.key==='ArrowLeft')location.href=current().url;});
  let pointer=null,lastTap=0;const surface=$('[data-cx-gesture]');
  surface.addEventListener('pointerdown',e=>{if(e.target.closest('a,button')||e.clientX<24||e.clientX>innerWidth-24)return;pointer={x:e.clientX,y:e.clientY,time:Date.now()};surface.setPointerCapture(e.pointerId);});
  surface.addEventListener('pointercancel',()=>pointer=null);
  surface.addEventListener('pointerup',e=>{if(!pointer)return;const dx=e.clientX-pointer.x,dy=e.clientY-pointer.y,duration=Date.now()-pointer.time;pointer=null;if(duration>800)return;if(Math.abs(dy)>65&&Math.abs(dy)>Math.abs(dx)*1.4){if(dy<0)next();else if(state.index>0&&!state.busy){state.index--;render();}}else if(Math.abs(dx)>90&&Math.abs(dx)>Math.abs(dy)*1.6){if(dx>0)reel.close();else location.href=current().url;}else if(Math.abs(dx)<12&&Math.abs(dy)<12){if(Date.now()-lastTap<320){save(current(),true);lastTap=0;}else lastTap=Date.now();}});
  let wheelTime=0;surface.addEventListener('wheel',e=>{if(Math.abs(e.deltaY)<20||Math.abs(e.deltaY)<Math.abs(e.deltaX))return;e.preventDefault();if(Date.now()-wheelTime<550)return;wheelTime=Date.now();if(e.deltaY>0)next();else if(state.index>0&&!state.busy){state.index--;render();}},{passive:false});
  addEventListener('storage',e=>{if(e.key===key){ids=new Set(safeRead(key,[]).map(String));syncSaved();}});
  window.CercevoExperience={open,openRandom,feed,remember,save,syncSaved,quickVariant};
  document.querySelectorAll('cercevo-explore-nav').forEach(setupNav);syncSaved();
  document.addEventListener('shopify:section:load',e=>{e.target.querySelectorAll('cercevo-explore-nav').forEach(setupNav);syncSaved();});
  if(location.hash==='#cx-continue'){const journey=safeRead('cercevo:journey',null,sessionStorage);if(journey?.id){window.scrollTo(0,journey.scroll||0);open(journey,{url:journey.source});}}
  if(location.hash==='#cercevo-ar'){const target=document.querySelector('[data-cercevo-ar-note]');target?.scrollIntoView({block:'center'});target?.classList.add('cercevo-ar-box--spotlight');}
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cercevo-v5-interactions"] && !Shopify.designMode) return;
  try {
    (() => {
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const api = () => window.CercevoExperience;
  const parse = (node) => [...node.querySelectorAll('[data-cercevo-product]')].flatMap((n) => {
    try { return [JSON.parse(n.textContent)]; } catch { return []; }
  });

  /* ---------- Duvar araması ---------- */
  let wallTarget = null, searchRevision = 0, searchTimer;
  let dialog = null;

  function ensureDialog() {
    if (dialog) return dialog;
    dialog = document.createElement('dialog');
    dialog.className = 'cx-wall-dialog';
    dialog.innerHTML =
      '<header><h2>Duvarınıza bir eser seçin</h2><button type="button" aria-label="Kapat">×</button></header>' +
      '<p>Seçtiğiniz eser bu konumda sabit kalır; otomatik yenileme onu değiştirmez.</p>' +
      '<input type="search" aria-label="Eser adı veya sanatçı ara" placeholder="Eser adı veya sanatçı ara">' +
      '<p role="status"></p><div class="cx-wall-results"></div>';
    document.body.append(dialog);
    dialog.querySelector('header button').onclick = () => dialog.close();
    dialog.addEventListener('close', () => {
      searchRevision++;
      clearTimeout(searchTimer);
      wallTarget?.trigger?.focus?.();
    });
    dialog.querySelector('input').addEventListener('input', () => {
      searchRevision++;
      clearTimeout(searchTimer);
      searchTimer = setTimeout(searchWall, 250);
    });
    return dialog;
  }

  async function searchWall() {
    const rev = ++searchRevision;
    const root = wallTarget?.root;
    const q = dialog.querySelector('input').value.trim();
    const status = dialog.querySelector('[role=status]');
    const results = dialog.querySelector('.cx-wall-results');
    status.textContent = '';
    results.replaceChildren();
    try {
      let products;
      if (!q) {
        /* Arama boşken sayfadaki bilinen eserleri göster — ağa gitmeye gerek yok. */
        products = parse(document).slice(0, 12);
      } else {
        const base = (root && root.dataset.root) || '/';
        const u = new URL(base + 'search/suggest.json', location.origin);
        u.searchParams.set('q', q);
        u.searchParams.set('resources[type]', 'product');
        u.searchParams.set('resources[limit]', '10');
        u.searchParams.set('resources[options][unavailable_products]', 'hide');
        const r = await fetch(u, { signal: AbortSignal.timeout(10000) });
        if (!r.ok) throw Error();
        products = (await r.json()).resources.results.products.map((p) => ({
          ...p, image: (p.featured_image && p.featured_image.url) || p.image,
        }));
      }
      if (rev !== searchRevision) return;
      if (!products.length) status.textContent = 'Eşleşen eser bulunamadı.';
      for (const product of products) {
        const button = document.createElement('button');
        button.type = 'button';
        const image = document.createElement('img');
        image.src = product.image || '';
        image.alt = '';
        image.loading = 'lazy';
        const name = document.createElement('span');
        name.textContent = product.title;
        button.append(image, name);
        button.onclick = async () => {
          button.disabled = true;
          try {
            /* suggest.json bizim şemamızı taşımaz — tam kaydı ürün uç noktasından al. */
            const u = new URL(product.url, location.origin);
            u.searchParams.set('section_id', 'cercevo-product-feed');
            const r = await fetch(u, { signal: AbortSignal.timeout(10000) });
            if (!r.ok) throw Error();
            const selected = parse(new DOMParser().parseFromString(await r.text(), 'text/html'))[0];
            if (!selected) throw Error();
            if (!dialog.open || rev !== searchRevision) return;
            wallTarget.root.cercevoSetSlot(wallTarget.slot, selected);
            dialog.close();
          } catch {
            status.textContent = 'Eser yüklenemedi. Tekrar deneyin.';
            button.disabled = false;
          }
        };
        results.append(button);
      }
    } catch {
      if (rev === searchRevision) status.textContent = 'Arama yüklenemedi. Tekrar deneyin.';
    }
  }

  document.addEventListener('cercevo:wall-search', (event) => {
    wallTarget = { root: event.target, slot: event.detail.slot, trigger: document.activeElement };
    const d = ensureDialog();
    d.querySelector('input').value = '';
    d.showModal();
    searchWall();
    d.querySelector('input').focus();
  });

  /* ---------- Galeri slaytları ---------- */
  function gallery(g) {
    if (g.dataset.slidesReady) return;
    g.dataset.slidesReady = 'true';
    g.dataset.slide = '0';

    const stage = g.querySelector('.cercevo-discovery__mosaic-wrap');
    if (!stage) return;

    const featuredUrl = g.dataset.slide2Url || '';
    const featuredTitle = g.dataset.slide2Collection || 'Özel seçki';
    /* İkinci slayt için bir koleksiyon seçilmediyse slayt hiç kurulmaz — boş bir
       vaat göstermektense o slaydı atlamak daha dürüst. */
    const slides = featuredUrl ? [0, 2, 1] : [0, 2];

    const copy = document.createElement('div');
    copy.className = 'cx-slide-copy';
    copy.innerHTML = '<p data-promo-kicker></p><h2></h2><p data-promo-body></p><a></a>';
    stage.append(copy);

    const nav = document.createElement('div');
    nav.className = 'cx-slide-nav';
    nav.setAttribute('role', 'group');
    nav.setAttribute('aria-label', 'Galeri slaytları');
    stage.append(nav);

    let active = 0;
    const labels = { 0: 'Galeri', 1: 'Müzeden duvarınıza', 2: 'Sizin Eseriniz' };
    const buttons = slides.map((slide, i) => {
      const b = document.createElement('button');
      b.type = 'button';
      b.textContent = String(i + 1);
      b.setAttribute('aria-label', labels[slide]);
      b.setAttribute('aria-pressed', String(i === 0));
      b.onclick = () => show(i);
      nav.append(b);
      return b;
    });

    function show(i) {
      active = ((i % slides.length) + slides.length) % slides.length;
      const slide = slides[active];
      g.dataset.slide = String(slide);
      buttons.forEach((b, j) => b.setAttribute('aria-pressed', String(j === active)));

      const kicker = copy.querySelector('[data-promo-kicker]');
      const heading = copy.querySelector('h2');
      const body = copy.querySelector('[data-promo-body]');
      const link = copy.querySelector('a');
      link.classList.toggle('is-custom', slide === 2);

      if (slide === 1) {
        kicker.textContent = '';
        heading.textContent = g.dataset.slide2Title || 'Bir koleksiyon. Sizin yorumunuz.';
        body.textContent = 'Seçki yükleniyor…';
        link.textContent = 'Koleksiyonu keşfet';
        link.href = featuredUrl;
        g.cercevoSetCollection?.(featuredUrl).then((ok) => {
          if (g.dataset.slide !== '1') return;
          body.textContent = ok
            ? (g.dataset.slide2Body || featuredTitle + ' ile kendi duvarınızı kurun.')
            : 'Seçki yüklenemedi. Koleksiyon bağlantısından devam edebilirsiniz.';
        });
      } else if (slide === 2) {
        kicker.textContent = '';
        heading.textContent = g.dataset.slide3Title || 'Sizin hikâyeniz, sizin duvarınız.';
        body.textContent = g.dataset.slide3Body || 'Sevdiğiniz görseli kişisel bir esere dönüştürün.';
        link.textContent = g.dataset.slide3Button || 'Sizin Eseriniz';
        link.href = g.dataset.slide3Url || '/pages/sizin-eseriniz';
      } else {
        g.cercevoSetCollection?.(g.dataset.feedUrl);
      }
    }

    /* Sahnede yatay sürükleme slayt değiştirir. Kaza eseri tetiklenen tıklamayı
       bastırmak için capture aşamasında bir kez engelleniyor. */
    let pointer = null, suppressClick = false;
    stage.addEventListener('click', (e) => {
      if (suppressClick) { e.preventDefault(); e.stopImmediatePropagation(); suppressClick = false; }
    }, true);
    stage.addEventListener('pointerdown', (e) => {
      if (e.target.closest('.cx-slide-nav,.cx-wall-search,a')) return;
      pointer = { x: e.clientX, y: e.clientY };
    });
    stage.addEventListener('pointerup', (e) => {
      if (!pointer) return;
      const dx = e.clientX - pointer.x, dy = e.clientY - pointer.y;
      pointer = null;
      if (Math.abs(dx) > 32 && Math.abs(dx) > Math.abs(dy) * 1.15) {
        suppressClick = true;
        show(active + (dx < 0 ? 1 : -1));
        setTimeout(() => { suppressClick = false; }, 120);
      }
    });
    stage.addEventListener('pointercancel', () => { pointer = null; });
  }

  const start = () => document.querySelectorAll('.cx-presentation-gallery').forEach(gallery);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', start);
})();
  } catch(e) { console.error(e); }
})();

})();
